export function formatToDecimalString(value, precision) {
  let formattedValue = 0;
  if(typeof value === 'string' || typeof value === 'number') {
    value = parseFloat(value);
    if(!isNaN(value)) {
      formattedValue = value.toFixed(precision);
      return formattedValue;
    }
  }
  return formattedValue.toFixed(precision);
}

export default { formatToDecimalString };